import { render } from "./FormRelManyPageBlock.vue?vue&type=template&id=9d49a91a"
import script from "./FormRelManyPageBlock.vue?vue&type=script&lang=js"
export * from "./FormRelManyPageBlock.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bezbedno/admin/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/Components/FormCustom/FormRelManyPageBlock.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9d49a91a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9d49a91a', __exports__)) {
    console.log('reload')
    api.reload('9d49a91a', __exports__)
  }
  
  module.hot.accept("./FormRelManyPageBlock.vue?vue&type=template&id=9d49a91a", () => {
    console.log('re-render')
    api.rerender('9d49a91a', render)
  })

}


export default __exports__